import {combineReducers}    from 'redux'
import {FetchedAccounts}    from "./FetchedAccounts"
import {BudgetByAccount}    from "./BudgetByAccount"

export const BudgetForStrategies = combineReducers({
  FetchedAccounts,
  BudgetByAccount,
})

